import { useState } from "react";
import { X, Power, AlertTriangle, ShieldAlert } from "lucide-react";

export default function EngineCutDialog({ vehicle, action, onConfirm, onClose }) {
  const isCut = action === "cut";
  const [ack, setAck] = useState(false);
  const [reason, setReason] = useState("");
  const speed = vehicle.last_position?.speed || 0;
  const moving = speed > 3;
  const submit = () => {
    if (isCut && !ack) return;
    onConfirm({ confirmed: true, confirmed_at: new Date().toISOString(), reason: reason.trim() || undefined });
  };
  return (
    <div className="fixed inset-0 z-[3000] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" onClick={onClose} data-testid="engine-cut-dialog">
      <div className={`glass rounded-lg w-full max-w-md p-5 animate-slidein border ${isCut ? "border-destructive/50" : "border-[#10B981]/40"}`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <p className="font-bold text-base flex items-center gap-2">
            <ShieldAlert className={`w-5 h-5 ${isCut ? "text-destructive" : "text-[#10B981]"}`} />
            {isCut ? "Bloquer le prochain démarrage" : "Autoriser le démarrage"}
          </p>
          <button onClick={onClose} data-testid="cut-cancel-btn" className="text-muted-foreground hover:text-foreground"><X className="w-4 h-4" /></button>
        </div>

        <p className="text-sm">
          Vous allez <b className={isCut ? "text-destructive" : "text-[#10B981]"}>{isCut ? "BLOQUER LE PROCHAIN DÉMARRAGE" : "AUTORISER LE DÉMARRAGE"}</b> de <b>{vehicle.name}</b>
          <span className="data text-muted-foreground"> · {vehicle.plate}</span>.
        </p>

        {isCut && (
          <p className="text-xs text-muted-foreground mt-2">
            L'immobilisation ne s'applique qu'à un véhicule à l'arrêt, contact coupé et avec une position récente. Le serveur refusera la commande si ces conditions ne sont pas réunies.
          </p>
        )}

        {isCut && moving && (
          <div className="mt-3 rounded-md bg-destructive/15 border border-destructive/40 p-3 flex items-start gap-2" data-testid="cut-moving-warning">
            <AlertTriangle className="w-4 h-4 text-destructive shrink-0 mt-0.5" />
            <p className="text-xs text-destructive font-semibold">Véhicule EN MOUVEMENT ({Math.round(speed)} km/h). L'immobilisation ne doit se faire qu'à l'arrêt — la commande sera refusée par le serveur.</p>
          </div>
        )}

        {isCut && (
          <label className="mt-3 flex flex-col gap-1 text-xs" data-testid="cut-reason-label">
            <span className="text-muted-foreground">Motif (facultatif) : vol, maintenance, impayé…</span>
            <input value={reason} onChange={(e) => setReason(e.target.value)} data-testid="cut-reason-input"
              className="bg-secondary/60 border border-border rounded-md px-2 py-1.5 text-xs outline-none focus:border-[#17A2B8]" placeholder="Motif de l'immobilisation" />
          </label>
        )}

        {isCut && (
          <label className="mt-3 flex items-start gap-2 text-xs cursor-pointer select-none" data-testid="cut-confirm-checkbox-label">
            <input type="checkbox" checked={ack} onChange={(e) => setAck(e.target.checked)} data-testid="cut-confirm-checkbox" className="mt-0.5 w-4 h-4 accent-[#17A2B8]" />
            <span>Je comprends les risques et je confirme vouloir bloquer le prochain démarrage à distance.</span>
          </label>
        )}

        <div className="flex gap-2 mt-4">
          <button onClick={submit} disabled={isCut && !ack} data-testid="cut-confirm-btn"
            className={`flex-1 flex items-center justify-center gap-1.5 font-semibold py-2.5 rounded-md text-sm transition-colors disabled:opacity-40 ${isCut ? "bg-destructive hover:bg-red-600 text-white" : "bg-[#10B981] hover:bg-[#0ea371] text-white"}`}>
            <Power className="w-4 h-4" /> {isCut ? "Bloquer le démarrage" : "Autoriser le démarrage"}
          </button>
          <button onClick={onClose} data-testid="cut-cancel-btn-2" className="px-4 py-2.5 text-sm text-muted-foreground hover:text-foreground">Annuler</button>
        </div>
      </div>
    </div>
  );
}
